import { ISuggestion } from '../../models'

export enum SuggestionsTypeKeys {
  ADD_SUGGESTION = 'ADD_SUGGESTION',
  ADD_SUGGESTION_SUCCESSFUL = 'ADD_SUGGESTION_SUCCESSFUL',
  IS_LOADING_SUGGESTIONS = 'IS_LOADING_SUGGESTIONS'
}

export interface IAddSuggestionAction {
  type: typeof SuggestionsTypeKeys.ADD_SUGGESTION
  payload: ISuggestion
}

export interface IAddSuggestionSuccessfulAction {
  type: typeof SuggestionsTypeKeys.ADD_SUGGESTION_SUCCESSFUL
}

export interface ISetIsLoadingSuggestionsAction {
  type: typeof SuggestionsTypeKeys.IS_LOADING_SUGGESTIONS
  payload: boolean
}

export type SuggestionsActionTypes =
  | IAddSuggestionAction
  | IAddSuggestionSuccessfulAction
  | ISetIsLoadingSuggestionsAction
